import { render } from "./CartViewCart.vue?vue&type=template&id=bbfc2a02&ts=true"
import script from "./CartViewCart.vue?vue&type=script&lang=ts"
export * from "./CartViewCart.vue?vue&type=script&lang=ts"

import "./CartViewCart.vue?vue&type=style&index=0&id=bbfc2a02&lang=scss"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__